import PhotosWrapper from './PhotosWrapper';

export default PhotosWrapper;
